module.exports = "<menu></menu>\n<h3>Experience</h3>\n<div class=\"section\" *ngFor=\"let workplace of experience\">\n    <div class=\"sectionHeader\">\n        <span>{{workplace.experienceHeader}}</span>\n    </div>\n    <div class=\"sectionDescription\">\n        <p>{{workplace.description}}</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/+cv/experience/experience.html
// module id = ../../../../../src/app/+cv/experience/experience.html
// module chunks = 1